var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    viewBox: "0 0 57 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0L0 9.04155L14.2222 17.9501L28.4444 9.04155L14.2222 0ZM42.6667 0L28.4444 9.04155L42.6667 17.9501L56.8889 9.04155L42.6667 0ZM0 26.9917L14.2222 36.0332L28.4444 26.9917L14.2222 17.9501L0 26.9917ZM42.6667 17.9501L28.4444 26.9917L42.6667 36.0332L56.8889 26.9917L42.6667 17.9501ZM14.2222 38.9584L28.4444 48L42.6667 38.9584L28.4444 30.0499L14.2222 38.9584Z",
    fill: "#0062FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropBoxIcon);
export default __webpack_public_path__ + "static/media/drop-box-icon.1a6cb692c8c1096dd95261d5cb4ce102.svg";
export { ForwardRef as ReactComponent };